export const formatDeviation = (
    targetQuantity: number,
    actualQuantity: number | undefined,
    emptyPlaceholder = '-'
): string => {
    if (actualQuantity === undefined) {
        return emptyPlaceholder;
    }

    const deviation = actualQuantity - targetQuantity;
    return deviation > 0 ? `+${deviation}` : `${deviation}`;
};
